import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_requestClientInfo = "1.3.6.1.4.1.311.21.20";
export class RequestClientInfo {
    constructor(params = {}) {
        this.clientId = 0;
        this.machineName = "";
        this.userName = "";
        this.processName = "";
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], RequestClientInfo.prototype, "clientId", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String })
], RequestClientInfo.prototype, "machineName", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String })
], RequestClientInfo.prototype, "userName", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String })
], RequestClientInfo.prototype, "processName", void 0);
